import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table.config';

const ItemStockScreen = () => {
  const ItemStockTable = useTable('item_stock', tableConfig);
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  React.useEffect(() => {
    const filters = {
      warehouse_id: selectedWarehouse?.id,
    };

    ItemStockTable.boot(filters);
  }, []);

  return (
    <Page className="fixed">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'Item Stock'}
        isLoading={StateLoading}
      />

      <Page.Navigation toolbar>
        <ItemStockTable.Tools downloadable isLoading={StateLoading} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <ItemStockTable.Render />
          )}
        </div>

      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <ItemStockTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default ItemStockScreen;
